(function () {
  'use strict';

  angular.module('ringbaPortal').component('changelogDelta', {
    controller: ChangelogDeltaController,
    bindings: {
      delta: '<',
      wide: '<'
    },
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/changelog/changelog-delta/changelog-delta.view.html'
  });

  function ChangelogDeltaController(
    buildChangeList
  ) {
    'ngInject';

    const vm = this;

    vm.changes = [];

    vm.$onChanges = onChanges;

    function onChanges() {
      vm.changes = buildChangeList(vm.delta);
    }
  }
})();
